import { XpoApiError } from '@shared/classes/error/xpo-api-error';

export class ReweighApiError extends XpoApiError {
  constructor(aMessage: string, aCause?: any) {
    super(aMessage, aCause);
  }
}
